import type { State, Action } from './typings'
import {
  openAction,
  closeAction,
  commitAction,
  setDataAction,
  loadDataAction,
  initApptAction,
  toFiltersAction,
  toResultsAction,
  prevScreenAction,
  rescheduleAction,
  setCloseableProducer,
  setResultsPageAction,
  setRequireACWOppSchedulingAction,
} from './actions'

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'open':
      return openAction(state, action.payload)
    case 'toFilters':
      return toFiltersAction(state, action.payload)
    case 'toResults':
      return toResultsAction(state, action.payload)
    case 'prev':
      return prevScreenAction(state)
    case 'setData':
      return setDataAction(state, action.payload)
    case 'loadData':
      return loadDataAction(state)
    case 'initAppt':
      return initApptAction(state, action.payload)
    case 'setResultsPage':
      return setResultsPageAction(state, action.payload)
    case 'commit':
      return commitAction(state, action.payload)
    case 'close':
      return closeAction(state)
    case 'reschedule':
      return rescheduleAction(state, action.payload)
    case 'setCloseable':
      return setCloseableProducer(state, action.payload)
    case 'setRequireACWOppScheduling':
      return setRequireACWOppSchedulingAction(state, action.payload)
  }
}
